module.exports = __webpack_public_path__ + "img/isaac_1.32562509.png";